export function initCollectionOverview() {
    const wrapper = document.querySelector('.collections-overview__filters.collection-filter');
    const collectionItems = Array.from(document.querySelectorAll('.tmp-collections-overview__grid-collection'));
    const checkboxes = wrapper?.querySelectorAll('input[type="checkbox"]') || [];
    const clearButton = wrapper?.querySelector('.collection-filter-clear');
    const countEl = wrapper?.querySelector('.collection-filter-toggle .collection-filter-count');
    const dropdown = wrapper?.querySelector('.collection-filter-dropdown');
    const toggleBtn = wrapper?.querySelector('.collection-filter-toggle');
    const loadMoreBtn = document.getElementById('collectionsOverviewLoadMoreBtn');
    const progressText = document.getElementById('postCollectionOverviewProgressText');
    const progressBar = document.getElementById('postCollectionOverviewProgressBar');
    const activeFiltersContainer = document.getElementById('collectionOverviewActiveFilters');
  
    const ITEMS_PER_PAGE = 12;
    let currentVisibleCount = 0;
  
    function updateCountDisplay(count) {
      if (countEl) {
        countEl.textContent = count > 0 ? `(${count})` : '';
      }
    }
  
    function getFilteredItems() {
      const selectedCodes = Array.from(checkboxes)
        .filter(cb => cb.checked)
        .map(cb => cb.dataset.code);
  
      return collectionItems.filter(item => {
        const codesString = item.dataset.codes || '';
        const codes = codesString.split(',').map(s => s.trim()).filter(Boolean);
        return selectedCodes.length === 0 || codes.some(code => selectedCodes.includes(code));
      });
    }
  
    function updateProgress(visibleCount, totalCount) {
      if (progressText) {
        progressText.textContent = `Showing ${visibleCount} of ${totalCount}`;
      }
      if (progressBar) {
        const percent = totalCount === 0 ? 0 : (visibleCount / totalCount) * 100;
        progressBar.style.width = `${percent}%`;
      }
    }
  
    function showItems(itemsToShow) {
      collectionItems.forEach(item => item.style.display = 'none');
      itemsToShow.forEach(item => item.style.display = '');
  
    }
  
    function renderActiveFilters() {
      if (!activeFiltersContainer) return;
      activeFiltersContainer.innerHTML = '';
  
      const checked = Array.from(checkboxes).filter(cb => cb.checked);
  
      checked.forEach(cb => {
        const pill = document.createElement('div');
        pill.className = 'tmp-collections-overview__filters-active-pill';
  
        const label = document.createElement('span');
        label.textContent = cb.value;
  
        const removeBtn = document.createElement('button');
        removeBtn.className = 'tmp-collections-overview__filters-active-pill-remove';
        removeBtn.innerHTML = '&times;';
        removeBtn.setAttribute('aria-label', 'Remove filter');
  
        removeBtn.addEventListener('click', () => {
          cb.checked = false;
          filterAndRender(true);
        });
  
        pill.appendChild(label);
        pill.appendChild(removeBtn);
        activeFiltersContainer.appendChild(pill);
      });
    }
  
    function filterAndRender(reset = true) {
      const filteredItems = getFilteredItems();
      updateCountDisplay(Array.from(checkboxes).filter(cb => cb.checked).length);
  
      if (reset) currentVisibleCount = 0;
  
      const toShow = filteredItems.slice(0, currentVisibleCount + ITEMS_PER_PAGE);
      currentVisibleCount = toShow.length;
  
      showItems(toShow);
      updateProgress(currentVisibleCount, filteredItems.length);
  
      if (loadMoreBtn) {
        loadMoreBtn.classList.toggle('hidden', currentVisibleCount >= filteredItems.length);
      }
  
      renderActiveFilters();
    }
  
    checkboxes.forEach(cb => {
      cb.addEventListener('change', () => filterAndRender(true));
    });
  
    clearButton?.addEventListener('click', (e) => {
      e.preventDefault();
      checkboxes.forEach(cb => cb.checked = false);
      filterAndRender(true);
      activeFiltersContainer.innerHTML = '';
    });
  
    loadMoreBtn?.addEventListener('click', () => {
      const filteredItems = getFilteredItems();
      const nextBatch = filteredItems.slice(0, currentVisibleCount + ITEMS_PER_PAGE);
      currentVisibleCount = nextBatch.length;
      showItems(nextBatch);
      updateProgress(currentVisibleCount, filteredItems.length);
  
      if (loadMoreBtn) {
        loadMoreBtn.style.display = currentVisibleCount < filteredItems.length ? 'flex' : 'none';
      }
    });
  
    toggleBtn?.addEventListener('click', () => {
      const isOpen = dropdown.classList.toggle('open');
      toggleBtn.classList.toggle('open', isOpen);
    });
  
    filterAndRender(true);
  }
  